<p-panel
  [toggleable]="true"
  [(collapsed)]="collapsed"
  toggler="header"
  [attr.data-testid]="'system-recording-module-panel'"
>
  <ng-template #header>
    <div class="flex items-center justify-between w-full gap-6">
      <div class="flex items-center gap-2">
        @if (moduleData().hasInScopeFunctions) {
          <div class="w-2 h-2 bg-primary rounded-full"></div>
        }
        <span class="text-lg font-medium">
          {{ moduleData().translatedName || moduleData().name }}
        </span>
      </div>

      <div class="flex items-center gap-2 min-w-0 flex-1 max-w-xs">
        <span class="text-sm whitespace-nowrap">{{ completedCount() }}/{{ totalCount() }}</span>
        <div class="flex-1">
          <p-progressBar
            [value]="(completedCount() / totalCount()) * 100"
            [showValue]="false"
            [class]="completedCount() === totalCount() ? 'completed-progress' : ''"
            [style]="{'height': '4px', 'background-color': '#64738c'}"
          ></p-progressBar>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  @if (!collapsed()) {
    <div class="relative">
      @if (isSaving()) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-black/20">
          <app-loading />
        </div>
      }

      @for (funcEntry of moduleData().functions; track funcEntry.uniqueId) {
        <app-system-recording-function-row
          [projectId]="projectId"
          [functionEntry]="funcEntry"
          [moduleId]="moduleData().id"
          [hasDuplicates]="hasDuplicates(funcEntry)"
          [isReadOnly]="isReadOnly()"
          (functionChanged)="onFunctionChanged()"
        />
      }

      @if (hasChanges() && areAllFunctionsValid() && completedCount() > 0) {
        <div class="flex justify-end mt-4">
          <app-project-step-save-button (clicked)="saveModule()" />
        </div>
      }
    </div>
  }
</p-panel>
